import { useEffect, useState } from 'react';
import { FileAttachment } from 'api/attachments';
import { TaskId } from 'api/models';
import { localStorageWorkspacePath } from 'components/organisms/image-preview';
import { RoutePaths } from 'constant';
import { useLocalStorageSession } from 'hooks/use-local-storage-session';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';
import {
  useAllAttachmentVersionById,
  useAttachmentById,
} from 'queries/attachments';

export const useAttachmentDetails = (
  attachmentId: number,
  compareAttachmentId?: number,
) => {
  const { data, isLoading: isLoadingForLatestAttachment } =
    useAttachmentById(attachmentId);

  const { data: listOfAttachment, isLoading: isLoadingForAllAttachment } =
    useAllAttachmentVersionById(attachmentId);

  const [attachment, setAttachment] = useState<FileAttachment>();
  const [latestVersion, setLatestVersion] = useState<FileAttachment>();
  const [selectedVersion, setSelectedVersion] = useState<FileAttachment>();
  const [versionFileList, setVersionFileList] = useState<FileAttachment[]>();
  const [isChatSectionVisible, setChatSectionVisiblity] = useState(false);
  const [isVersionSectionVisible, setVersionSectionVisiblity] = useState(true);
  const [leftAttachment, setLeftAttachment] = useState<FileAttachment>();
  const [rightAttachment, setRightAttachment] = useState<FileAttachment>();
  const [isChatSectionComparisonVisible, setChatSectionComparisonVisiblity] =
    useState(false);
  const navigateToTask = useNavigateToTask();
  const { getItem } = useLocalStorageSession(localStorageWorkspacePath);

  useEffect(() => {
    if (!isLoadingForLatestAttachment) {
      setAttachment(data);
      setSelectedVersion(attachment);
    }
    if (!isLoadingForAllAttachment) {
      setLatestVersion(
        listOfAttachment?.filter(
          (attachmentFile) => attachmentFile.latestVersion === true,
        )[0],
      );
      setVersionFileList(listOfAttachment);

      if (compareAttachmentId) {
        setLeftAttachment(
          listOfAttachment?.filter(
            (file) => file.attachmentId === Number(attachmentId),
          )[0],
        );
        setRightAttachment(
          listOfAttachment?.filter(
            (file) => file.attachmentId === Number(compareAttachmentId),
          )[0],
        );
      }
    }
  }, [
    attachment,
    attachmentId,
    compareAttachmentId,
    data,
    isLoadingForAllAttachment,
    isLoadingForLatestAttachment,
    listOfAttachment,
  ]);

  const onOpenParentTask = () => {
    if (
      selectedVersion?.projectId !== undefined &&
      selectedVersion.sourceId !== undefined
    ) {
      const storedPath = getItem();

      navigateToTask(
        TaskId(selectedVersion.projectId, selectedVersion.sourceId),
        {},
        storedPath ?? RoutePaths.home,
      );
    }
  };

  return {
    attachment,
    latestVersion,
    setLatestVersion,
    selectedVersion,
    setSelectedVersion,
    versionFileList,
    setVersionFileList,
    isChatSectionVisible,
    setChatSectionVisiblity,
    isVersionSectionVisible,
    setVersionSectionVisiblity,
    isLoadingForAllAttachment,
    leftAttachment,
    setLeftAttachment,
    rightAttachment,
    setRightAttachment,
    isChatSectionComparisonVisible,
    setChatSectionComparisonVisiblity,
    onOpenParentTask,
  };
};
